import { Player } from "../classes/Player";

export const getActivePlayersCount = (players: Player[]) => {
  let count = 0;
  for (let idx = 0; idx < players.length; idx++)
  {
    if (players[idx].isActive())
    {
      count++;
    }
  }
  return count;
}